import "./index.css";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import AddUsernameForm from "./forms/AddUsernameForm";
import HomePage from "./pages/HomePage/HomePage";
import { Pathnames } from "./components/molecules/BottomNavigation";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import Layout from "./layouts/Layout";

import { supabase } from "./lib/api";

import { getUserSession } from "./services/getUserSession";
import { QueryKeys } from "./services/types";
import AddLinkPage from "./pages/AddLinkPage/AddLinkPage";
import AuthPage from "./pages/AuthPage/AuthPage";

const HomePageWrapper = () => {
  const [session, setSession] = useState<any>(null);

  const navigate = useNavigate();

  const { data: userSession } = useQuery({
    queryFn: getUserSession,
    queryKey: [QueryKeys.SESSION],
  });

  useEffect(() => {
    if (userSession) {
      setSession(userSession);
    }

    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, [userSession]);

  if (!session) {
    navigate(Pathnames.AUTH);
    return null;
  } else if (session && !session?.user?.user_metadata?.username) {
    return <AddUsernameForm userSession={session?.user} />;
  } else {
    return <HomePage />;
  }
};

export default function App() {
  return (
    <StyledMain>
      <Routes>
        <Route path={Pathnames.AUTH} element={<AuthPage />} />
        <Route element={<Layout />}>
          <Route index path={Pathnames.HOME} element={<HomePageWrapper />} />
          <Route path={Pathnames.PROFILE} element={<ProfilePage />} />
          <Route path={Pathnames.ADD_LINK} element={<AddLinkPage />} />
        </Route>
      </Routes>
    </StyledMain>
  );
}

const StyledMain = styled.main`
  max-width: 1200px;
  margin: auto;
  padding-bottom: 50px;
`;
